import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Brush,
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "1-07-2020",
    sales: 80,
  },
  {
    name: "2-07-2020",
    sales: 120,
  },
  {
    name: "3-07-2020",
    sales: 40,
  },
  {
    name: "4-07-2020",
    sales: 90,
  },
  {
    name: "5-07-2020",
    sales: 45,
  },
  {
    name: "6-07-2020",
    sales: 130,
  },
  {
    name: "7-07-2020",
    sales: 45,
  },
  {
    name: "8-07-2020",
    sales: 130,
  },
  {
    name: "9-07-2020",
    sales: 60,
  },
  {
    name: "10-07-2020",
    sales: 65,
  },
  {
    name: "11-07-2020",
    sales: 40,
  },
  {
    name: "12-07-2020",
    sales: 80,
  },
];

export default function NewSaleGraph() {
  return (
    <div>
      <ResponsiveContainer
        className="linechart_outer"
        width="100%"
        height={350}
      >
        <h2>Grafik Penjualan (Rupiah)</h2>
        <LineChart width={500} height={100} data={data}>
          <Legend layout="horizontal" verticalAlign="top" align="right" />
          <CartesianGrid strokeDasharray="1 1" vertical={false} opacity={1} />
          <XAxis dataKey="name" axisLine={false} tickLine={false} />
          <YAxis axisLine={false} tickLine={false} />

          <Line
            className="linechart_inner"
            type="monotone"
            dataKey="sales"
            stroke="#005CFF"
            fill="#005CFF"
            strokeWidth={3}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
